<template>
    <div class="noDataWrap">
        <img src="../assets/home/emptyData.png?v1232" v-if="whiteMode">

        <img src="../assets/stats/Stats_nulldata.png?v1232" v-if="!whiteMode">
        <p class="sorry" :class="{'grayColor':whiteMode}">Sorry , no content yet</p>
    </div>
</template>

<script>
    export default {
        name: 'loading',
        data: function () {
            return {};
        },
        props: ['whiteMode',],

    };
</script>
<style lang="less" scoped>

    .noDataWrap {
        width: 100%;
        margin: 0 auto 13.33333333rem;
        padding: 4.4rem 0 3rem;
    }

    .noDataWrap img {
        width: 9.4rem;
        display: block;
        margin: 0 auto;
        height: auto;
    }

    .sorry {
        font-size: .9rem;
        color: #929cad;
        text-align: center;
    }

    .grayColor {
        color: #b5bcc4 !important;
    }
</style>



// WEBPACK FOOTER //
// nodata.vue?7c5c9327